import React, { useState } from 'react';
import './index.css';
import { custom_post } from '../../utils/api';

interface FileUploaderProps {
   
    onFileChange: (files: any[]) => void; // Accept an array of objects containing file details
}

const FileInputNew: React.FC<FileUploaderProps> = (props) => {
    const [files, setFiles] = useState<File[]>([]);
    
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            const selectedFiles = Array.from(event.target.files);
            setFiles(selectedFiles);
            console.log("selectedFiles", selectedFiles)

            props.onFileChange(selectedFiles)
        }
    };

    const handleRemoveFile = (index: number) => {
        const updated_files = files.filter((_, i) => i !== index);    
        setFiles(updated_files);        
        props.onFileChange(updated_files);

    };

    return (
        <div className="file-uploader-premium">
            <input
                type="file"
                multiple
                onChange={handleFileChange}
                id="file-input"
                className="file-input"
            />
            <label htmlFor="file-input" className="file-label">
                Select Files
            </label>

            {files.length > 0 && (
                <div className="file-list">
                    <h3>Selected Files:</h3>
                    <ul>
                        {files.map((file, index) => (
                            <li key={index} className="file-item">
                                {file.name}
                                <button
                                    className="remove-file-button"
                                    onClick={() => handleRemoveFile(index)}
                                >
                                    Remove
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default FileInputNew;
